import useUser from './useUser';
import { AxiosResponse } from 'axios';
import axios from 'axios';
import { URL_ORDERS, URL_SHIPPING, URL_ORDER_DELIVERY } from 'constants/url';
import { IOrderPackages, IOrderPackagesProviders, IOrderShippingRequest } from 'interfaces/orderPackages.interface';
import { IShippingResponse } from 'interfaces/shipping.interface';

export default function useOrderPackages() {
  const { jwt } = useUser();

  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getOrderPackages = async (orderNumber: number | undefined): Promise<IOrderPackages> => {
    console.log('getOrderPackages');

    return axios.get(`${URL_ORDERS}/packages/${orderNumber}`, { headers }).then((response: AxiosResponse) => {
      return response.data;
    });
  };

  const getOrderPackagesProviders = async (orderNumber: number | undefined): Promise<IOrderPackagesProviders> => {
    return axios.get(`${URL_ORDERS}/packages/${orderNumber}`, { headers }).then((response: AxiosResponse) => {
      return response.data;
    });
  };

  const createPackage = async (data: IOrderShippingRequest): Promise<IShippingResponse> => {
    return axios.post(URL_SHIPPING, data, { headers }).then((response: AxiosResponse) => {
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error('Respuesta inesperada');
      }
    });
  };

  const createPackageDelivery = async (data: IOrderShippingRequest): Promise<IShippingResponse> => {
    return axios.post(URL_ORDER_DELIVERY, data, { headers }).then((response: AxiosResponse) => {
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error('Respuesta inesperada');
      }
    });
  };
  return { createPackage, getOrderPackagesProviders, getOrderPackages, createPackageDelivery };
}
